import { render } from "./ColorInput.vue?vue&type=template&id=583f6aee&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=js"
export * from "./ColorInput.vue?vue&type=script&lang=js"

import "./ColorInput.vue?vue&type=style&index=0&id=583f6aee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-583f6aee"

export default script